import { BaseMapper } from '@ps/utils';
import { Quota } from '@ps/survey-utils';

import { SurveyQuotaEntryDto } from '../dtos/survey-quota.dto';
import { QuotaCriteriaMapper } from './quota.mapper';

export class AdvancedTargetingQuotaMapper extends BaseMapper<
  SurveyQuotaEntryDto,
  Quota
> {
  private readonly _criteriaMapper = new QuotaCriteriaMapper();

  public fromDto(dto: SurveyQuotaEntryDto): Quota {
    return {
      buyerQuotaId: dto.buyer_quota_id,
      groupKey: dto.group_key,
      requiredCount: dto.required_count,
      flexible: dto.flexible,
      criteria: this._criteriaMapper.fromDto(dto.criteria),
      percentage: dto.percentage,
      maximum: dto.maximum,
      minimum: dto.minimum,
      quotaCategory: dto.quota_category,
      currentTarget: dto.current_target,
      fielded: dto.achieved,
    };
  }
}
